import Gift from "@material-symbols/svg-500/rounded/featured_seasonal_and_gifts.svg?react";
import { memo } from "react";

import { IconCreator } from "./_utils/icon-creator";

import type { SVGIconProps } from "./_utils/icon-creator";

const GiftIcon = (props: SVGIconProps) => {
	const Icon = () => IconCreator({ ...props, svgIcon: Gift });
	return <Icon />;
};

export default memo(GiftIcon);
